import {ReadonlyDeep} from 'type-fest';
import {FarmState} from '../../ApiStore';

export default (state?: ReadonlyDeep<FarmState>) => !state;
